import React, { Fragment } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Text, StyledCard, StyledCardContent, NoInformation } from '../../index';

import PatientCard from './PatientCard';

const PatientMedicalRecord = ({ data }) => {
    return (
        <div
            style={{
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                rowGap: '15px',
            }}
        >
            {!_.isEmpty(data) ? (
                <Fragment>
                    <PatientCard data={data} />

                    {!_.isEmpty(data.patient_summaries) && (
                        <Fragment>
                            <StyledCard>
                                <StyledCardContent
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        rowGap: '10px',
                                    }}
                                >
                                    <Text $color="pink" $fontSize="14px">
                                        Session Name
                                    </Text>
                                    <Text>{data.patient_summaries[0]?.session?.meet?.name}</Text>
                                    <Text $color="pink" $fontSize="14px">
                                        Session Description
                                    </Text>
                                    <Text>
                                        {data.patient_summaries[0]?.session?.meet?.description}
                                    </Text>
                                    <Text $color="pink" $fontSize="14px">
                                        Provider
                                    </Text>
                                    <Text>
                                        {
                                            data.patient_summaries[0]?.session?.meet?.staff?.user
                                                ?.fullname
                                        }
                                    </Text>
                                    <Text $color="pink" $fontSize="14px">
                                        Counseling Service
                                    </Text>
                                    <Text>
                                        {data.patient_summaries[0]?.session?.meet?.hospital?.name}
                                    </Text>
                                </StyledCardContent>
                            </StyledCard>
                            <StyledCard>
                                <StyledCardContent
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        rowGap: '10px',
                                    }}
                                >
                                    <Text $color="pink" $fontSize="14px">
                                        Mental Status Examination (MSE)
                                    </Text>
                                    <Text>{data.patient_summaries[0]?.MSE}</Text>
                                </StyledCardContent>
                            </StyledCard>
                            <StyledCard>
                                <StyledCardContent
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        rowGap: '10px',
                                    }}
                                >
                                    <Text $color="pink" $fontSize="14px">
                                        Diagnosis
                                    </Text>
                                    <Text>{data.patient_summaries[0]?.diagnosis}</Text>
                                    <Text $color="pink" $fontSize="14px">
                                        Treatment
                                    </Text>
                                    <Text>{data.patient_summaries[0]?.treatment}</Text>
                                </StyledCardContent>
                            </StyledCard>
                        </Fragment>
                    )}
                </Fragment>
            ) : (
                <NoInformation />
            )}
        </div>
    );
};

PatientMedicalRecord.propTypes = {
    data: PropTypes.object,
};

export default PatientMedicalRecord;
